<script setup lang="ts">

import { faFilterCircleXmark } from '@fortawesome/pro-regular-svg-icons'

import { FilterDateRange } from '@shared/ui/filters'
import { BtnIcon, BtnPrimary } from '@shared/ui/buttons'

import { useFiltersDisciplineProgressReports } from '../model/filters-discipline-progress-reports.hook'

defineOptions({
  name: 'FiltersDisciplineProgressReports',
})

const {
  refDueDateRange,
  isLoading,
  search,
  clearFilters,
} = useFiltersDisciplineProgressReports()
</script>

<template>
  <div class="filters-discipline-progress-reports">
    <FilterDateRange
      v-model="refDueDateRange"
      presets
      class="filters-discipline-progress-reports__date"
      label="Due date & time"
      placeholder="Search"
      :disabled="isLoading"
    />
    <BtnPrimary
      text="Search"
      :disabled="isLoading"
      @click="search"
    />
    <BtnIcon
      :icon="faFilterCircleXmark"
      color="red"
      tooltip-text="Clear filters"
      :disabled="isLoading"
      @click="clearFilters"
    />
  </div>
</template>

<style scoped lang="scss" src="./FiltersDisciplineProgressReports.scss" />
